import React from "react";
import fetcher from '../API';
import BoostForm from './BoostForm'
import _ from 'lodash'
import { Table, Tag, Button, message } from 'antd';
import { Link } from 'react-router-dom';


class Boosts extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            boosts: {}
        }
        this.onBoostButtonTouch = this.onBoostButtonTouch.bind(this);
        
    }

    componentDidMount() {
        this.getBoostsList()
        
    }

    getBoostsList = () => {
        this.setState({
            loading: true
        })
        fetcher.get('/api/v1/_internal/ranking/boosts').then(response => {
            this.setState({ 
                boosts: _.mapKeys(response.data, 'productId'),
                loading: false
             });
        }).catch(error => {
            console.log(error);
            this.setState({
                loading: false
            })
            message.error(error && error.response && JSON.stringify(error.response.data) || "Request Failed");
        })
    }

    onBoostButtonTouch(item) {
        if (!item.productId || item.productId.length == 0) {
            message.error('请输入productId');
        }
        if (!item.score || item.score.length == 0) {
            message.error('请输入score');
        }
        const data = {
            productId: item.productId,
            score: item.score
        }
        fetcher.post('api/v1/_internal/ranking/boosts', data).then(response => {
            console.log(response.data);
            let oldItem = this.state.boosts[response.data.productId];
            oldItem.score = response.data.score;

            this.setState({
                boosts: {
                    ...this.state.boosts,
                    [response.data.productId]: oldItem
                }
            });
            message.success('boost 成功');
        }).catch(error => {
            message.error(error && error.response && JSON.stringify(error.response.data) || 'boost 失败');
        });
    }

    removeBoosts = (productId) => {
        this.setState({
            loading: true
        })
        fetcher.delete(`/api/v1/_internal/ranking/boosts/${productId}`).then(response => {
            this.getBoostsList()
            message.success('remove 成功');
        }).catch(error => {
            console.log(error);
            message.error(error && error.response && JSON.stringify(error.response.data) || 'remove 失败');
            this.setState({
                loading: false
            })
        })
    }

    render() {
        const { boosts,loading } = this.state
        const columns = [
            {
              title: 'product id',
              dataIndex: 'productId',
              key: 'productId',
              render: text => 
              <Link to={ `/discover/${text}` } target="_blank">
                <span>{ text }</span>
              </Link>
            },
            {
              title: 'score',
              dataIndex: 'score',
              key: 'score',
            },
            {
                title: 'create by',
                dataIndex: 'createdBy',
                key: 'createdBy',
            },
            {
                title: 'tags',
                dataIndex: 'tags',
                key: 'tags',
                render: tags => tags && tags.map(tag => <Tag key={tag}>{tag}</Tag>),
            },
            {
                title: 'operation',
                key: 'operation',
                render: record => <Button type="primary" onClick={()=>this.removeBoosts(record.productId)}>Remove</Button>,
            }
        ]
        return (
            <div className="container-fluid mt-3" style={{
                background: '#fff',
                padding: '30px 15px 30px 15px'
            }}>
                <BoostForm onBoost={ this.onBoostButtonTouch } />
                <Table 
                columns={columns} 
                dataSource={boosts && Object.values(boosts)} 
                loading={loading} 
                rowKey={record => record.createdAt}/>
            </div>
        );
    }
}

export default Boosts;